$(function() {
  function modalAnimation(element, displayed, height) {
    var modalContent = document.querySelector('.x-modal-content');

    element.velocity({
        opacity: 0,
        display: "none"
      }, {
        duration: 100,
        easing: "easeIn"
      })
      .velocity(
        { height: 0 }, {
        begin: function () { displayed.classList.add('before-display'); },
        complete: function () {
          displayed.velocity({
            display: 'block',
            visibility: 'visible'
          }, {
            complete: function () {
              element.classList.remove('before-display');
              element.classList.remove('displayed');
              element.setAttribute('style', '');
            }
          });
        }
      }, {delay: 1000, easing: "easeIn"});
    modalContent.velocity({
      height: height + 60
      }, {
      complete: function () {
        modalContent.setAttribute('style', '');
        displayed.classList.add('displayed');
      }
    }, {delay: 1000, easing: "easeIn"});
  }

  $('body').on('click', '.x-signup-animation', function(event) {
    if(event.target && $(event.target).hasClass('x-signup-animation')) {
      var animatedServices = document.querySelector('.x-animated-services');
      var animatedSignUp = document.querySelector('.x-animated-signup');
      var animatedSignUpHeight = animatedSignUp.clientHeight;
      modalAnimation(animatedServices, animatedSignUp, animatedSignUpHeight);
      event.preventDefault();
    }
  });

  $('body').on('click', '.x-signin-animation', function (event) {
    var animatedSignUp = document.querySelector('.x-animated-signup');
    var animatedSignIn = document.querySelector('.x-animated-signin');
    var animatedSignInHeight = animatedSignIn.clientHeight;
    modalAnimation(animatedSignUp, animatedSignIn, animatedSignInHeight);
    event.preventDefault();
  });

  $('body').on('click', '.x-signup-back-animation', function (event) {
    var animatedSignIn = document.querySelector('.x-animated-signin');
    var animatedSignUp = document.querySelector('.x-animated-signup');
    var animatedSignUpHeight = animatedSignUp.clientHeight;
    modalAnimation(animatedSignIn, animatedSignUp, animatedSignUpHeight);
    event.preventDefault();
  });

  $('body').on('click', '.x-2fa-animation', function (event) {
    var animatedSignIn = document.querySelector('.x-animated-signin');
    var animated2fa = document.querySelector('.x-animated-2fa');
    var animated2faHeight = animated2fa.clientHeight;
    modalAnimation(animatedSignIn, animated2fa, animated2faHeight);
    event.preventDefault();
  });

  $('body').on('click', '.x-agree-more', function(e){
    e.preventDefault();
    var that = $(this);
    $(that).next('span').removeClass('hide');
    $(that).remove();
  });

  $('.x-expand-more').on('click', function(e) {
    $(this).next('span').removeClass('hide');
    $(this).remove();
    e.preventDefault();
  });
});
